// 1. TimelineImageDialog Component
// src/components/Timeline/components/TimelineImageDialog.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Button
} from '@mui/material';
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';

// Import or define the Image interface
interface Image {
  id: string;
  url: string;
  title?: string;
  description?: string;
  location?: string;
  date?: string;
  tags?: string[];
  uploadedBy?: {
    id: string;
    name: string;
    avatar?: string;
  };
}

interface TimelineImageDialogProps {
  open: boolean;
  images: (string | Image)[];
  currentIndex: number;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
}

const TimelineImageDialog: React.FC<TimelineImageDialogProps> = ({
  open,
  images,
  currentIndex,
  onClose,
  onNext,
  onPrev
}) => {
  // Get the current image URL, handling both string and Image object cases
  const getCurrentImageUrl = (): string => {
    if (!images || images.length === 0 || currentIndex >= images.length) {
      return '';
    }
    
    const currentImage = images[currentIndex];
    return typeof currentImage === 'string' ? currentImage : currentImage.url;
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Photos</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center' }}>
          {images.length > 0 && (
            <Box sx={{ position: 'relative' }}>
              <img 
                src={getCurrentImageUrl()} 
                alt="Timeline event" 
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '70vh',
                  objectFit: 'contain',
                  display: 'block',
                  margin: '0 auto'
                }} 
              />
              
              {images.length > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                  <Button 
                    onClick={onPrev} 
                    variant="outlined" 
                    startIcon={<ExpandMoreIcon sx={{ transform: 'rotate(90deg)' }} />}
                  >
                    Previous
                  </Button>
                  <Typography>
                    {currentIndex + 1} of {images.length}
                  </Typography>
                  <Button 
                    onClick={onNext} 
                    variant="outlined" 
                    endIcon={<ExpandMoreIcon sx={{ transform: 'rotate(-90deg)' }} />}
                  >
                    Next
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TimelineImageDialog;